/* eslint-disable no-unused-vars */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Swal from "sweetalert2";
import { MenuItem, InputAdornment, Container } from "@material-ui/core";
import { AppConfig } from "../app-config";
import Header from "./SigninHeader";
import { useHistory } from "react-router-dom";
import MuiPhoneNumber from "material-ui-phone-number";
import Popover from "@material-ui/core/Popover";
import InfoIcon from "@material-ui/icons/Info";
import Tab from "components/Tabs/Tab";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  container: {
    display: "flex",
    height: "100%",
    alignItems: "center",
    marginTop: "0.5em",
    // justifyContent: "center",
  },
  // paper: {
  //   minHeight: "45vh",
  //   height: "auto",
  //   width: "70%",
  //   minWidth: "300px",
  //   margin: "1rem",
  //   display: "flex",
  //   flexGrow: "1",
  //   // verticalAlign: "middle",
  // },
  form: {
    width: "100%",
    display: "flex",
    height: "auto",
    // alignItems: "center",
    // justifyContent: "center",
    padding: "2rem 86px",
    flexDirection: "column",
  },
  loginLink: {
    color: "gray",
    marginTop: "20px",
  },
  text: {
    width: "100%",
    marginBottom: "1.4rem",
  },
  button: {
    marginTop: "1rem",
    // borderRadius: "5px",
    // background: "rgba(72,187,120,1)",
    // color: "#FEFEFE",
  },
  inline: {
    marginLeft: "1rem",
  },
  large: {
    width: theme.spacing(12),
    height: theme.spacing(12),
    boxShadow: "none",
    marginRight: "1rem",
  },
  spinner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  textDiv: {
    width: "90%",
    // marginBottom: "1.4rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textField: {
    width: "48%",
  },
  textFieldLift: {
    width: "48%",
    position: "relative",
    bottom: 4,
  },
  adornment: {
    color: "grey",
    position: "relative",
    left: -45,
    bottom: -5,
  },
  popover: {
    pointerEvents: "none",
  },
  paper: {
    padding: theme.spacing(1),
    display: "flex",
    flexGrow: "1",
  },
  info: {
    position: "relative",
    top: -20,
    left: -20,
  },
}));

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

export default function CreateCompany() {
  const [Company, setCompany] = React.useState({
    name: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    entity_type_id: "",
    username: "",
    password: "",
    zone_speciality_id: "",
    zone_id: "",
  });
  const [error, setError] = React.useState({
    name: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    entity_type_id: "",
    username: "",
    password: "",
    zone_speciality_id: "",
    zone_id: "",
  });

  const [loading, setLoading] = React.useState(false);
  const [alert, showAlert] = React.useState(false);
  const [step, setStep] = React.useState(0);
  const [entities, setEntities] = React.useState([]);
  const [specialty, setSpecialty] = React.useState([]);
  const [zones, setZones] = React.useState([]);
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [entityName, setEntityName] = React.useState("");
  const [showTag, setShowTag] = React.useState(false);
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleChange = (event) => {
    setError({ ...error, [event.target.name]: "" });
    setCompany({
      ...Company,
      [event.target.name]: event.target.value,
    });
  };

  const handleEntityChange = (event) => {
    setError({ ...error, [event.target.name]: "" });
    if (event.target.value) setIsDisabled(false);
    if (event.target.value === 3) {
      setShowTag(true);
    } else setShowTag(false);
    setCompany({
      ...Company,
      [event.target.name]: event.target.value,
    });
  };

  const handleNameChange = (event) => {
    setError({ ...error, [event.target.name]: "" });
    setEntityName(`${event.target.value}`);
    setCompany({
      ...Company,
      [event.target.name]: event.target.value,
    });
  };

  const handlePhoneChange = (value) => {
    setError({ ...error, phone: "" });
    setCompany({
      ...Company,
      phone: value,
    });
  };

  const history = useHistory();

  const handleBlurField = () => {
    if (Company.name) {
      let rawName = Company.name;
      let parsedName = rawName.replace(/\s/g, "").toLocaleLowerCase();
      if (
        parsedName[parsedName.length - 1] === "c" &&
        parsedName[parsedName.length - 2] === "z" &&
        parsedName[parsedName.length - 3] === "f"
      ) {
      } else {
        setCompany({
          ...Company,
          name: `${Company.name}`,
        });
        // return setError({ ...error, name: "Add FZC suffix to your company name" });
      }
    }
  };

  const getZones = async () => {
    try {
      const response = await fetch(`${AppConfig.URL}/active-zones`, {
        method: "GET",
      });
      const { status, data, message } = await response.json();
      if (status === true) {
        setZones(data);
      } else {
        Swal.fire("", message, "info");
      }
    } catch (error) {
      Swal.fire(
        "Something went wrong",
        "Unable to get available zones",
        "error"
      );
    }
  };

  const handleSubmit = async () => {
    const {
      name,
      first_name,
      last_name,
      email,
      phone,
      address,
      entity_type_id,
      username,
      password,
      zone_speciality_id,
      zone_id,
    } = Company;

    if (!name) {
      return setError({ ...error, name: "Please provide a company name" });
    }
    if (!first_name) {
      return setError({ ...error, first_name: "Please provide a First name" });
    }
    if (!last_name) {
      return setError({ ...error, last_name: "Please provide a Last name" });
    }
    if (!email) {
      return setError({ ...error, email: "Please provide a Email" });
    }
    if (phone?.length < 6) {
      return setError({ ...error, phone: "Please provide a valid Phone" });
    }
    // if (!address) {
    //   return setError({ ...error, address: "Please provide a Address" });
    // }
    // if (!rc_no) {
    //   return setError({ ...error, rc_no: "Please provide a Rc no" });
    // }
    if (!username) {
      return setError({ ...error, username: "Please provide a username" });
    }
    if (!password) {
      return setError({ ...error, password: "Please provide a password" });
    }
    if (!entity_type_id) {
      return setError({
        ...error,
        entity_type_id: "Please provide a Entity type id",
      });
    }

    // if (phone.length > 11) {
    //   return setError({ ...error, phone: "Phone number must be 11 digits" });
    // }
    let body = {};
    body = {
      name,
      first_name,
      last_name,
      email,
      phone,
      address,
      entity_type_id,
      username,
      password,
      zone_speciality_id,
      zone_id,
    };
    try {
      setLoading(true);

      let reqMethod = "POST";
      let url = AppConfig.URL + "/company/register";

      const { status, message } = await fetch(url, {
        method: reqMethod,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage["token"],
        },
        body: JSON.stringify(body),
      }).then((res) => res.json());
      if (status) {
        setLoading(false);
        showAlert(true);
        setCompany({
          name: "",
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          address: "",
          entity_type_id: "",
          zone_speciality_id: "",
          zone_id: "",
        });
        history.push("/login");
        setTimeout(() => {
          closeAlert();
        }, 1000);
        // }
        // else if (!window.navigator.online) {
        //   Swal.fire("Internet", "Check your connection", "error");
      } else {
        Swal.fire("", message, "info");
        setLoading(false);
      }
    } catch (err) {
      Swal.fire("Something went wrong", "Unable to register company", "info");
      setLoading(false);
    }
  };

  const changeStep = () => setStep(step + 1);

  const getEntities = async () => {
    try {
      const response = await fetch(`${AppConfig.URL}/entity_types/list`, {
        method: "GET",
      });
      const { status, data, message } = await response.json();
      if (status === true) {
        setEntities(data.data);
      } else {
        Swal.fire("", message, "info");
      }
    } catch (error) {
      Swal.fire("Something went wrong", "Unable to get entity types", "error");
    }
  };

  const getSpecialties = async () => {
    try {
      const response = await fetch(`${AppConfig.URL}/speciality/zone/list`, {
        method: "GET",
      });
      const { status, data, message } = await response.json();
      if (status === true) {
        setSpecialty(data.speciality);
      } else {
        Swal.fire("", message, "info");
      }
    } catch (error) {
      Swal.fire("Something went wrong", "Unable to get specialties", "error");
    }
  };

  React.useEffect(() => {
    getEntities();
    getSpecialties();
    getZones();
  }, []);

  React.useEffect(() => {
    if (Company.entity_type_id == 2) {
      Swal.fire({
        // imageUrl: "/check.png",
        title: "Enterprise Registration requirement",
        text: "In other to register an enterprise you need to carry out registry search to confirm availability of its name",
        confirmButtonColor: "#48BB78",
        confirmButtonText: "Start registry search",
        showCancelButton: true,
        cancelButtonText: "",
      }).then((res) => (res.isConfirmed ? history.push("/search") : null));
    }
  }, [Company]);

  const closeAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    showAlert(false);
  };

  const handleValidation = () => {
    if (!step) {
      return false;
    }
    if (
      (step === 1 && Company.name && Company.zone_speciality_id) ||
      (step === 1 && Company.name && Company.zone_id)
    ) {
      return false;
    }
    if (
      step === 2 &&
      Company.first_name &&
      Company.last_name &&
      Company.email &&
      Company.phone &&
      Company.address
    ) {
      return false;
    }
    if (step === 3 && Company.email && Company.password) {
      return false;
    }
    return true;
  };

  // console.log(handleValidation());

  const steps = [
    "Company information",
    "Personal information",
    "Login credentials",
  ];

  return (
    <div>
      <Header />
      <Snackbar
        open={alert}
        autoHideDuration={2000}
        onClose={closeAlert}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert onClose={closeAlert} severity="success">
          Company Created Successfully!
        </Alert>
      </Snackbar>

      <Container className={classes.container}>
        <div>
          <img
            src="/register.png"
            style={{
              height: "85vh",
              objectFit: "cover",
              objectPosition: "center",
              width: "100%",
            }}
          />
        </div>
        <Paper elevation={0} className={classes.paper}>
          <form className={classes.form} noValidate autoComplete="off">
            {step ? (
              <div
                style={{ marginBottom: "40px", cursor: "pointer" }}
                onClick={() => setStep(step - 1)}
              >
                <img src="/ArrowLeft.png" />
              </div>
            ) : null}
            <Typography
              variant="h4"
              style={{ fontSize: "35px", fontWeight: "700" }}
            >
              {!step
                ? "Select your entity type"
                : step == 1 && Company.entity_type_id == "3"
                ? "Free Zone Registration"
                : step == 1 && Company.entity_type_id == "4"
                ? "Zone Management Registration"
                : "Register"}
            </Typography>

            <h3 style={{ marginTop: "15px", marginBottom: "54px" }}>
              Please select your company’s entity type to get started on OPMS
            </h3>
            {step ? (
              <div className={classes.textDiv}>
                <Tab activeStep={step} steps={steps} />
              </div>
            ) : null}
            {step == 0 && (
              <>
                <div className={classes.textDiv}>
                  <TextField
                    id={
                      !error.entity_type_id
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    error={!!error.entity_type_id}
                    select
                    fullWidth
                    variant="outlined"
                    label="Entity type"
                    name="entity_type_id"
                    value={Company.entity_type_id}
                    onChange={(e) => handleEntityChange(e)}
                    helperText={
                      error.entity_type_id ? error.entity_type_id : ""
                    }
                  >
                    {entities.map((option) => (
                      <MenuItem
                        key={option.entity_type_id}
                        value={option.entity_type_id}
                      >
                        {option.entity_type}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </>
            )}

            {step === 1 && (
              <>
                <div className={classes.textDiv}>
                  <TextField
                    label="Entity Name"
                    name="name"
                    error={!!error.name}
                    id={
                      !error.name
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    required
                    helperText={error.name ? error.name : ""}
                    margin="normal"
                    fullWidth
                    type="text"
                    // className={classes.textField}
                    variant="outlined"
                    disabled={isDisabled}
                    value={entityName}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {showTag ? "FZC" : null}
                        </InputAdornment>
                      ),
                    }}
                    onBlur={(e) => handleBlurField(e)}
                    onChange={(e) => handleNameChange(e)}
                  />
                </div>
                {Company.entity_type_id == "3" ? (
                  <div className={classes.textDiv}>
                    <TextField
                      error={!!error.zone_speciality_id}
                      select
                      fullWidth
                      variant="outlined"
                      label="Zone specialty"
                      name="zone_speciality_id"
                      style={{ marginTop: "1em" }}
                      value={Company.zone_speciality_id}
                      onChange={(e) => handleChange(e)}
                      helperText={
                        error.zone_speciality_id ? error.zone_speciality_id : ""
                      }
                    >
                      {specialty.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                ) : Company.entity_type_id == "4" ? (
                  <div className={classes.textDiv}>
                    <TextField
                      error={!!error.zone_id}
                      select
                      fullWidth
                      variant="outlined"
                      label="Affilated Free Zone Company (FZC)"
                      name="zone_id"
                      style={{ marginTop: "1em" }}
                      value={Company.zone_id}
                      onChange={(e) => handleChange(e)}
                      helperText={error.zone_id ? error.zone_id : ""}
                    >
                      {zones.map((option) => (
                        <MenuItem key={option.zone_id} value={option.zone_id}>
                          {option.zone_name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                ) : null}

                {/* {entities.map((option) => (
                   <MenuItem
                     key={option.entity_type_id}
                     value={option.entity_type_id}
                   >
                     {option.entity_type}
                   </MenuItem>
                 ))} */}
              </>
            )}

            {step === 2 && (
              <>
                <div className={classes.textDiv}>
                  <TextField
                    label="First name"
                    name="first_name"
                    error={!!error.first_name}
                    id={
                      !error.first_name
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    required
                    className={classes.textField}
                    value={Company?.first_name}
                    helperText={error.first_name ? error.first_name : ""}
                    margin="normal"
                    type="text"
                    variant="outlined"
                    onChange={(e) => handleChange(e)}
                  />
                  <TextField
                    label="Last name"
                    name="last_name"
                    error={!!error.last_name}
                    id={
                      !error.last_name
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    required
                    className={classes.textField}
                    value={Company?.last_name}
                    helperText={error.last_name ? error.last_name : ""}
                    margin="normal"
                    type="text"
                    variant="outlined"
                    onChange={(e) => handleChange(e)}
                  />
                </div>

                <div className={classes.textDiv}>
                  <TextField
                    label="Email"
                    name="email"
                    error={!!error.email}
                    id={
                      !error.email
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    required
                    className={classes.textField}
                    value={Company?.email}
                    helperText={error.email ? error.email : ""}
                    margin="normal"
                    type="text"
                    variant="outlined"
                    onChange={(e) => handleChange(e)}
                  />
                  <MuiPhoneNumber
                    label="Phone"
                    name="phone"
                    defaultCountry={"ng"}
                    error={!!error.phone}
                    id={
                      !error.phone
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    required
                    className={classes.textField}
                    helperText={error.phone ? error.phone : ""}
                    margin="normal"
                    type="text"
                    value={Company?.phone}
                    variant="outlined"
                    onChange={handlePhoneChange}
                  />
                </div>
                <div className={classes.textDiv}>
                  <TextField
                    label="Address"
                    name="address"
                    error={!!error.address}
                    fullWidth
                    id={
                      !error.address
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    required
                    value={Company?.address}
                    // className={classes.textField}
                    helperText={error.address ? error.address : ""}
                    margin="normal"
                    type="text"
                    variant="outlined"
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </>
            )}

            {step === 3 && (
              <>
                <div className={classes.textDiv}>
                  <TextField
                    label="Username"
                    name="username"
                    error={!!error.username}
                    id={
                      !error.username
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    required
                    fullWidth
                    value={Company?.username}
                    // className={classes.textField}
                    helperText={error.username ? error.username : ""}
                    margin="normal"
                    type="text"
                    variant="outlined"
                    onChange={(e) => handleChange(e)}
                  />
                </div>
                <div className={classes.textDiv}>
                  <TextField
                    label="Password"
                    name="password"
                    fullWidth
                    error={!!error.password}
                    id={
                      !error.password
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    required
                    value={Company?.password}
                    // className={classes.textField}
                    helperText={error.password ? error.password : ""}
                    margin="normal"
                    type="password"
                    variant="outlined"
                    onChange={(e) => handleChange(e)}
                  />
                </div>
              </>
            )}

            {/*             
            {Company.entity_type_id == 3 && (
              <> */}
            {/* <div className={classes.textDiv}>
              <TextField
                label="Entity Name"
                name="name"
                error={!!error.name}
                id={
                  !error.name ? "outlined-basic" : "outlined-error-helper-text"
                }
                required
                helperText={error.name ? error.name : ""}
                margin="normal"
                type="text"
                className={classes.textField}
                variant="outlined"
                disabled={isDisabled}
                value={entityName}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {showTag ? "FZC" : null}
                    </InputAdornment>
                  ),
                }}
                onBlur={(e) => handleBlurField(e)}
                onChange={(e) => handleNameChange(e)}
              />
              <TextField
                label="Address"
                name="address"
                error={!!error.address}
                id={
                  !error.address
                    ? "outlined-basic"
                    : "outlined-error-helper-text"
                }
                required
                className={classes.textField}
                helperText={error.address ? error.address : ""}
                margin="normal"
                type="text"
                variant="outlined"
                onChange={(e) => handleChange(e)}
              />
              <TextField
                    label="RC number"
                    name="rc_no"
                    error={!!error.rc_no}
                    id={
                      !error.rc_no
                        ? "outlined-basic"
                        : "outlined-error-helper-text"
                    }
                    className={classes.textField}
                    helperText={error.rc_no ? error.rc_no : ""}
                    margin="normal"
                    type="text"
                    variant="outlined"
                    onChange={(e) => handleChange(e)}
                  />
            </div>

            <div className={classes.textDiv}>
              <TextField
                label="Username"
                name="username"
                error={!!error.username}
                id={
                  !error.username
                    ? "outlined-basic"
                    : "outlined-error-helper-text"
                }
                required
                className={classes.textField}
                helperText={error.username ? error.username : ""}
                margin="normal"
                type="text"
                variant="outlined"
                onChange={(e) => handleChange(e)}
              />
              <TextField
                label="Password"
                name="password"
                error={!!error.password}
                id={
                  !error.password
                    ? "outlined-basic"
                    : "outlined-error-helper-text"
                }
                required
                className={classes.textField}
                helperText={error.password ? error.password : ""}
                margin="normal"
                type="password"
                variant="outlined"
                onChange={(e) => handleChange(e)}
              />
            </div>
            <h3 style={{ marginTop: "25px" }}>Personal Information</h3>
            <div className={classes.textDiv}>
              <TextField
                label="First name"
                name="first_name"
                error={!!error.first_name}
                id={
                  !error.first_name
                    ? "outlined-basic"
                    : "outlined-error-helper-text"
                }
                required
                className={classes.textField}
                helperText={error.first_name ? error.first_name : ""}
                margin="normal"
                type="text"
                variant="outlined"
                onChange={(e) => handleChange(e)}
              />
              <TextField
                label="Last name"
                name="last_name"
                error={!!error.last_name}
                id={
                  !error.last_name
                    ? "outlined-basic"
                    : "outlined-error-helper-text"
                }
                required
                className={classes.textField}
                helperText={error.last_name ? error.last_name : ""}
                margin="normal"
                type="text"
                variant="outlined"
                onChange={(e) => handleChange(e)}
              />
            </div>

            <div className={classes.textDiv}>
              <TextField
                label="Email"
                name="email"
                error={!!error.email}
                id={
                  !error.email ? "outlined-basic" : "outlined-error-helper-text"
                }
                required
                className={classes.textField}
                helperText={error.email ? error.email : ""}
                margin="normal"
                type="text"
                variant="outlined"
                onChange={(e) => handleChange(e)}
              />
              <MuiPhoneNumber
                label="Phone"
                name="phone"
                defaultCountry={"ng"}
                error={!!error.phone}
                id={
                  !error.phone ? "outlined-basic" : "outlined-error-helper-text"
                }
                required
                className={classes.textField}
                helperText={error.phone ? error.phone : ""}
                margin="normal"
                type="text"
                value={Company?.phone}
                variant="outlined"
                onChange={handlePhoneChange}
              />
            </div> */}
            {/* </>
            )} */}

            <div className={classes.textDiv}>
              {step !== 3 ? (
                <Button
                  fullWidth
                  // autoFocus
                  variant="contained"
                  color="primary"
                  onClick={changeStep}
                  className={classes.button}
                  size="large"
                  disabled={
                    loading ||
                    !Company.entity_type_id ||
                    // !Company.specialty ||
                    handleValidation() ||
                    Company.entity_type_id == 2
                  }
                >
                  {step === 3 ? "Register" : "Continue"}
                </Button>
              ) : (
                <Button
                  fullWidth
                  // autoFocus
                  variant="outlined"
                  color="#FEFEFE"
                  onClick={handleSubmit}
                  className={classes.button}
                  size="large"
                  disabled={
                    loading || !Company.entity_type_id || handleValidation()
                  }
                >
                  {loading ? (
                    <div className={classes.spinner}>
                      <CircularProgress
                        style={{ height: "30px", width: "30px" }}
                      />
                    </div>
                  ) : step === 3 ? (
                    "Register"
                  ) : (
                    "Continue"
                  )}
                </Button>
              )}
            </div>
            <p
              className={classes.loginLink}
              tw="mt-8 text-sm text-gray-400 text-center"
            >
              Already have an account?{" "}
              <a href={"/login"} tw="border-b border-gray-500 border-dotted">
                Sign In
              </a>
            </p>
          </form>
          {/* {loading && (
            <div className={classes.spinner}>
              <CircularProgress />
              <Typography
                component="span"
                variant="body2"
                className={classes.inline}
                color="initial"
              >
                Submiting Company...
              </Typography>
            </div>
          )} */}
        </Paper>
      </Container>
    </div>
  );
}
